// Enter details to get your user name in email
<template>
  <div class="flex items-center min-h-screen w-full">
    <div
      class="w-full bg-white rounded shadow-lg p-8 m-4 md:max-w-sm md:mx-auto"
    >
      <div class="md:flex w-full">
        <div class="w-full py-10 px-5">
          <div class="flex items-center gap-2">
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
              ></path>
            </svg>
            <div class="text-right text-xl text-[#C04625]">
              Forgot Username
            </div>
          </div>
          <form class="mt-4 space-y-6" @submit.prevent="submit" novalidate>
            <div class="rounded-sm">
              <div class="flex flex-col">
                <text-input
                id="attorney_number"
                  label="USL Attorney Number"
                  :class="{ 'border-red-400': v$.form.attorney_number.$error }"
                  :errors="v$.form.attorney_number.$errors.map(e => e.$validator === 'required' ? 'Value is required' : e.$message)"
                  v-bind:value="form.attorney_number"
                  @blur="form.attorney_number = form.attorney_number?.trim(); v$.form.attorney_number.$touch()"
                  v-on:keyup="form.attorney_number = $event.target['value']"
                ></text-input>
              </div>
              <div class="flex flex-col mt-2">
                <text-input
                id="zip"
                  label="ZIP (Primary address)"
                  :class="{ 'border-red-400': v$.form.zip.$error }"
                  :errors="v$.form.zip.$errors.map(e => e.$validator === 'required' ? 'Value is required' : e.$message)"
                  v-bind:value="form.zip"
                  @blur="form.zip = form.zip?.trim(); v$.form.zip.$touch()"
                  v-on:keyup="form.zip = $event.target['value']"
                ></text-input>
              </div>
              <div class="flex flex-col mt-2">
                <text-input
                id="last_4_ssn"
                  label="EIN/SSN (last four digits)"
                  :class="{ 'border-red-400': v$.form.last_4_ssn.$error }"
                  :errors="v$.form.last_4_ssn.$errors.map(e => e.$validator === 'required' ? 'Value is required' : e.$message)"
                  v-bind:value="form.last_4_ssn"
                  @blur="form.last_4_ssn = form.last_4_ssn?.trim(); v$.form.last_4_ssn.$touch()"
                  v-on:keyup="form.last_4_ssn = $event.target['value']"
                ></text-input>
              </div>
            </div>
            <div>
              <button
                id="forgot-username"
                type="submit"
                class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white cobalt-button-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-50"
              >
                <span class="absolute left-0 inset-y-0 flex items-center pl-3">
                  <svg
                    class="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                    ></path>
                  </svg>
                </span>
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TextInput from "../Layout/Form/TextInput.vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { mapState } from "vuex";
export default {
  name: "Forgot Username",
  components: {
    TextInput,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  computed: mapState(["att_user"]),
  data: function() {
    return {
      form: {},
    };
  },
  validations() {
    return {
      form: {
        zip: {
          required,
        },
        attorney_number: {
          required,
        },
        last_4_ssn: {
          required,
        },
      },
    };
  },
  mounted() {},
  created() {
    this.$store.watch(
      () => this.$store.state.is_forgot,
      (value) => {
        console.log(value);
        if (value != 0 && value != false) {
          this.$toast.success(
            "Please check email for Username,You can login now!"
          );
          this.$router.push("/login");
        }
      }
    );
    this.$store.watch(
      () => this.$store.state.errors,
      (value) => {
        if (value.length != 0) {
          this.$toast.error("Sorry, Attorney not found!");
        }
      }
    );
  },
  methods: {
    submit: function() {
      this.v$.form.$touch(this.v$.form.errors);
      if (this.v$.form.$pending || this.v$.form.$error) return;
      this.$store.dispatch("forgotUsername", this.form);
    },
  },
};
</script>
